module.exports = __webpack_public_path__ + "static/media/startsida.3da5ce66.png";